const VIDEO_LANGUAGE_MAP = {
  en: "english",
  es: "spanish",
  he: "hebrew",
  pt: "portuguese",
};

export function toVideoLanguage(lang) {
  if (!lang) return "english";
  const normalized = lang.toLowerCase();
  return VIDEO_LANGUAGE_MAP[normalized] || "english";
}
